<template>
  <div>
    <LeadForm
      :formData="form"
      @update:formData="handleFormUpdate"
      class="mb-6"
      style="justify-content: center"
      @handleFormValid="handleFormValid" />
    <div class="d-flex" style="width: 100%; gap: 16px">
      <v-btn class="prev ma-0" text outlined @click="prevStep()" style="flex-basis: calc(50% - 8px)">이전</v-btn>
      <v-btn
        class="next ma-0"
        :style="{ opacity: !isFormValid ? '0.2' : '1' }"
        text
        outlined
        @click="handleClick()"
        style="flex-basis: calc(50% - 8px)"
        >다음</v-btn
      >
    </div>
  </div>
</template>

<script>
import LeadForm from '@/components/company/lead/LeadForm.vue';

export default {
  name: 'StoreInfo',
  components: {
    LeadForm,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    prevStep: {
      type: Function,
      default: () => {},
    },
    nextStep: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isFormValid: false,
    };
  },
  methods: {
    handleClick() {
      if (!this.isFormValid) {
        return;
      }

      this.nextStep();
    },
    handleFormValid(isValid) {
      this.isFormValid = isValid;
    },

    handleFormUpdate(newFormData) {
      this.$emit('update:form', newFormData);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../assets/scss/form.scss';
@import '../../../assets/scss/typo.scss';
</style>
